import { User } from "./user";
import { EUserType } from "../enum/e-user-type";
import { Observable } from "rxjs";
import { Package } from "../../packages/models/package";
import { Injector } from "@angular/core";
import { UserApiService } from "../user-api.service";
import { Subscription } from "../../subscription/models/subscription";
import { Address } from "src/app/models/address";

export class UserCoach extends User  {

  discriminator: EUserType = EUserType.Coach;
  compagnyNumber : string | null;
  address : Address;
  
  constructor(public injector: Injector) {
    super(injector);
    this.compagnyNumber = "";
    this.address = null;
  }
  
  public getPackage(): Observable<Package[]> {
    return this.injector.get(UserApiService).getPackage(this);
  }

  getSubscriptions(): Observable<Subscription[]> {
    return this.injector.get(UserApiService).getSubscriptions(this);
  }

}
